import React from "react"
import strings from "../../../../localization/strings"
import { Paper, Menu, MenuItem, Toggle } from "material-ui"
import { EJobDashboardCircleChartType } from "../../../../models"
import { EnumValues } from "enum-values"
import AccountStore from "../../../../stores/AccountStore"
interface IProps {
	showFilterItems: EJobDashboardCircleChartType[]
	handleUpdateShowFilterItems(event, valud): void
}

const SelectShowJobDashboardCircleChartFilterItemMenu: React.SFC<IProps> = (props: IProps) => {
	return (
		<Paper style={{ position: "absolute", top: 30, right: 40, zIndex: 10, paddingTop: 10 }}>
			<Menu style={{ textAlign: "left" }}>
				{(EnumValues.getValues(EJobDashboardCircleChartType) as EJobDashboardCircleChartType[]).filter(i => AccountStore.getPhasesEnabled() ? true : i !== EJobDashboardCircleChartType.Phases).map((item, index) => {
					const itemName = EnumValues.getNameFromValue(EJobDashboardCircleChartType, item)
					return (
						<MenuItem key={index} style={{ minHeight: 35 }}>
							<Toggle
								data-intercom-target={`ExceptionFilter-Toggle-${item}`}
								name={itemName}
								toggled={props.showFilterItems.includes(item)}
								label={strings[itemName]}
								onToggle={props.handleUpdateShowFilterItems}
								labelStyle={{ fontSize: 14 }}
							/>
						</MenuItem>
					)
				})}
			</Menu>
		</Paper>
	)
}

export default SelectShowJobDashboardCircleChartFilterItemMenu